import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "my-report-top" }
const _hoisted_4 = { class: "my-report-top-tab" }

import { event } from "vue-gtag-next";
import { useRoute, useRouter } from "vue-router";
import { computed, watch } from "vue";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import Graph from "@/views/pages/MyReport/MyGraph.vue";
import Calendar from "@/views/pages/MyReport/MyCalendar.vue";

const activeMenu = "my-report";

// ルートパラメータからタブを決める（未指定なら graph）

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentTab = computed<"graph" | "calendar">(() => {
  const tab = route.params.activeTab;
  return tab === "calendar" ? "calendar" : "graph";
});

// タブ切替時に URL を更新
function changeTab(tab: "graph" | "calendar") {
  router.replace({ name: "MyReport", params: { activeTab: tab } });
}

const componentId = computed(() =>
  currentTab.value === "graph"
    ? "generalpurpose03-00-a"
    : "generalpurpose03-00-b"
);
watch(
  () => route.params.activeTab,
  (newTab) => {
    // Google Analyticsにタブ切替を通知
    const tabName = newTab || "graph";
    event("tab_change", {
      tab_name: tabName,
    });
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId.value }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, { "active-menu": activeMenu }),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", {
              class: _normalizeClass(["my-report-top-tab-item", { 'is-active': currentTab.value === 'graph' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('graph')))
            }, _toDisplayString(_ctx.$t("myreport_graph_title")), 3),
            _createElementVNode("li", {
              class: _normalizeClass(["my-report-top-tab-item", { 'is-active': currentTab.value === 'calendar' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('calendar')))
            }, _toDisplayString(_ctx.$t("myreport_calendar_title")), 3)
          ])
        ]),
        (currentTab.value === 'graph')
          ? (_openBlock(), _createBlock(Graph, { key: 0 }))
          : (_openBlock(), _createBlock(Calendar, { key: 1 }))
      ]),
      _createVNode(Footer, {
        "scroll-target": componentId.value,
        "active-menu": activeMenu
      }, null, 8, ["scroll-target"])
    ])
  ], 8, _hoisted_1))
}
}

})